const STORAGE_KEY_PREFIX = 'hs-quote-tracking';

/**
 * Gets a value from session storage with the quote tracking prefix
 */
export function get(key) {
  try {
    const fullKey = `${STORAGE_KEY_PREFIX}:${key}`;
    return window.sessionStorage.getItem(fullKey);
  } catch (error) {
    console.log('hs-quote-tracking failed to get from session storage', {
      error,
      key
    });
    return null;
  }
}

/**
 * Sets a value in session storage with the quote tracking prefix
 */
export function set(key, value) {
  try {
    const fullKey = `${STORAGE_KEY_PREFIX}:${key}`;
    window.sessionStorage.setItem(fullKey, value);
  } catch (error) {
    console.log('hs-quote-tracking failed to set in session storage', {
      error,
      key,
      value
    });
  }
}

/**
 * Gets a value from storage, or sets and returns the default value if it doesn't exist
 * @returns A tuple of [value, wasSet] where wasSet is true if the value was newly set
 */
export function getOrSet(key, defaultValue) {
  const existingValue = get(key);
  if (existingValue === null) {
    set(key, defaultValue);
    return [defaultValue, true];
  }
  return [existingValue, false];
}